import axios from "axios";
import store from "@/store";
import { Message } from "element-ui";
import controller from "@/libs/controller";
const axios_config = {
  baseURL: process.env.VUE_APP_WEB_URL,
  withCredentials: true,
  timeout: 2500
};
const auth_header_name = "authorization";
const instance = axios.create(axios_config);
instance.interceptors.request.use(
  config => {
    if (store.state.token) {
      config.headers[auth_header_name] = `Bearer ${store.state.token}`;
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

const http = {
  axios,
  instance,
  auth_header_name,
  get: (url, param) => {
    var get_config = {
      params: param
    };
    return instance.get(url, get_config);
  },
  post: (url, data) => {
    return instance.post(url, data);
  },
  /**并发请求 [{url:"",data:""}]*/
  all: (getList, postList) => {
    let getInstanceList = [];
    if (getList && 0 < getList.length) {
      getInstanceList = getList.map(function(e) {
        return instance.get(e.url, e.data);
      });
    }
    let postInstanceList = [];
    if (postList && 0 < postList.length) {
      postInstanceList = postList.map(function(e) {
        return instance.post(e.url, e.data);
      });
    }
    var instanceList = [...getInstanceList, ...postInstanceList];
    return axios.all(instanceList);
  }
};
instance.interceptors.response.use(response => {
  if (response) {
    var auth_token = response.headers[auth_header_name];
    if (auth_token) {
      store.commit("setToken", auth_token);
    }
    if (200 === response.status) {
      controller.checkResult(response.data);
    } else {
      Message.error({
        message: "错误，无法处理该请求"
      });
    }
  }
  return response;
});
Object.assign(http, controller);
export default http;
